import HTTP from "../utils/HTTP";

/**
 * Subscription Service for Admin Panel
 * Handles all subscription-related API calls
 */

/**
 * Fetch all subscriptions with pagination and filters
 * @param {Object} params - Query parameters (status, page, limit)
 * @returns {Promise} API response
 */
export const fetchAllSubscriptions = (params = {}) => {
  return HTTP.get("/subscription/all", { params });
};

/**
 * Fetch subscription by ID
 * @param {number} id - Subscription ID
 * @returns {Promise} API response
 */
export const fetchSubscriptionById = (id) => {
  return HTTP.get(`/subscription/${id}`);
};

/**
 * Fetch subscription payments
 * @param {number} subscriptionId - Subscription ID
 * @returns {Promise} API response
 */
export const fetchSubscriptionPayments = (subscriptionId) => {
  return HTTP.get(`/subscription/${subscriptionId}/payments`);
};

/**
 * Cancel a subscription
 * @param {number} subscriptionId - Subscription ID
 * @param {boolean} cancelAtCycleEnd - If true, cancels at end of current cycle
 * @returns {Promise} API response
 */
export const cancelSubscription = (subscriptionId, cancelAtCycleEnd = false) => {
  return HTTP.post("/subscription/cancel", {
    subscription_id: subscriptionId,
    cancel_at_cycle_end: cancelAtCycleEnd,
  });
};

/**
 * Pause a subscription
 * @param {number} subscriptionId - Subscription ID
 * @returns {Promise} API response
 */
export const pauseSubscription = (subscriptionId) => {
  return HTTP.post("/subscription/pause", {
    subscription_id: subscriptionId,
  });
};

/**
 * Resume a paused subscription
 * @param {number} subscriptionId - Subscription ID
 * @returns {Promise} API response
 */
export const resumeSubscription = (subscriptionId) => {
  return HTTP.post("/subscription/resume", {
    subscription_id: subscriptionId,
  });
};

/**
 * Get subscription metrics for dashboard
 * @returns {Promise} API response with metrics
 */
export const getSubscriptionMetrics = () => {
  return HTTP.get("/subscription/admin/metrics");
};

/**
 * Create a subscription plan for a kid
 * @param {Object} data - Plan data
 * @returns {Promise} API response
 */
export const createSubscriptionPlan = (data) => {
  return HTTP.post("/subscription/plan/create", data);
};

/**
 * Fetch plans for a kid
 * @param {number} kidId - Kid ID
 * @returns {Promise} API response
 */
export const fetchKidPlans = (kidId) => {
  return HTTP.get(`/subscription/plans/${kidId}`);
};
